import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

interface Plan {
  metadata: {
    type?: 'pro' | 'teams' | 'plg';
    trial?: boolean;
  };
}

interface PractitionerState {
  currentPractitionerEntitlements?: {
    plans?: Plan[];
    plan_expiry?: string;
  };
}

interface RootState {
  practitionerState: PractitionerState;
}

export const useIsFreeUser = (): boolean => {
  const { currentPractitionerEntitlements } = useSelector(
    (state: RootState) => state.practitionerState
  );

  const plans = currentPractitionerEntitlements?.plans;

  const isAuraPro =
    plans?.some((plan) => plan.metadata?.type === 'pro') ?? false;
  const isAuraTeams =
    plans?.some((plan) => plan.metadata?.type === 'teams') ?? false;
  const isPLGUser =
    plans?.some((plan) => plan.metadata?.type === 'plg') ?? false;
  const isAuraProTrial =
    plans?.some((plan) => plan.metadata?.trial === true) ?? false;

  const auraProTrialPlanExpiry = currentPractitionerEntitlements?.plan_expiry;
  const auraProTrialRemainingSeconds = auraProTrialPlanExpiry
    ? dayjs(auraProTrialPlanExpiry).diff(dayjs(), 'second')
    : null;
  const isAuraProTrialExpired =
    isAuraProTrial && (auraProTrialRemainingSeconds ?? 1) <= 0;

  return isPLGUser && ((!isAuraPro && !isAuraTeams) || isAuraProTrialExpired);
};
